import React from 'react';
import ApexCharts from 'react-apexcharts';
import noData from "../../../src/assets/images/noData.png";

const TopTenChart = ({ data }) => {
  // Check if data is available
  if (!data || data.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img src={noData} height="255px" alt="No data available" />
      </div>
    );
  }

  // Prepare data for the chart
  const categories = data.map(item => item.supplier_name); // X-axis (Supplier Names)
  const totalTrades = data.map(item => item.total_trades); // Y-axis (Total Trades)

  const chartOptions = {
    chart: {
      type: 'bar',
      height: 350,
    },
    xaxis: {
      categories: categories, // X-axis labels (Supplier Names)
      title: {
        text: 'Supplier Name',
        style: {
          fontSize: '14px',
          fontFamily: 'Arial, sans-serif',
          fontWeight: "600",
          color: "#000000de",
        },
      },
    },
    yaxis: {
      title: {
        text: 'Total Trades',
        style: {
          fontSize: '14px',
          fontFamily: 'Arial, sans-serif',
          fontWeight: "600",
          color: "#000000de",
        },
      },
    },
    colors: categories.map((_, index) => (index % 2 === 0 ? '#f4a99b' : '#a5faa5')), // Alternating colors
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%', // Width of each bar
      },
    },
    dataLabels: {
      enabled: false, // Disable data labels inside bars
    },
    tooltip: {
      y: {
        formatter: function (value, { dataPointIndex }) {
          const supplier = data[dataPointIndex];
          return `
            <strong>Total Trades:</strong> ${supplier.total_trades}<br/>
            <strong>Total Quantity:</strong> ${supplier.total_qty.toLocaleString()}<br/>
            <strong>Total Price:</strong> ₹${supplier.total_price.toLocaleString()}
          `;
        },
      },
    },
    legend: {
      show: false,
    },
  };
  

  // Data series for the chart
  const chartSeries = [
    {
      name: '',
      data: totalTrades, // Y-axis data
    },
  ];

  return (
    <div>
      <ApexCharts
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default TopTenChart;
